(function () {
  "use strict";

  /* =========================================================
     This file mirrors the chart data in size-recommender.js
     (the product-page version) — kept in sync manually for now.
     If you add/edit a category, update BOTH files.
     ========================================================= */

  var FIELD_ORDER = ["chest", "waist", "shoulderKnee", "waistAnkle"];

  var BODY_4FIELD = [
    { age: "1-2Y", chest: 19, waist: 19, shoulderKnee: 16,   waistAnkle: 17   },
    { age: "2-3Y", chest: 20, waist: 20, shoulderKnee: 18.5, waistAnkle: 19   },
    { age: "3-4Y", chest: 21, waist: 21, shoulderKnee: 20.5, waistAnkle: 23   },
    { age: "4-5Y", chest: 22, waist: 22, shoulderKnee: 22.5, waistAnkle: 25.5 },
    { age: "5-6Y", chest: 23, waist: 23, shoulderKnee: 25,   waistAnkle: 26.5 },
    { age: "6-7Y", chest: 24, waist: 24, shoulderKnee: 27,   waistAnkle: 28   },
    { age: "7-8Y", chest: 25, waist: 25, shoulderKnee: 29.5, waistAnkle: 30.5 },
    { age: "8-9Y", chest: 26, waist: 26, shoulderKnee: 31.5, waistAnkle: 32.5 }
  ];

  var SIZE_CHARTS = {
    "tunic-set-till-knee": {
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "topLength", label: "Top length (till knee)" },
        { key: "waist", label: "Garment waist round" },
        { key: "pantLength", label: "Pant length above ankle" }
      ],
      garment: {
        "1-2Y": { chest: 22, topLength: 16,   waist: 17, pantLength: 16   },
        "2-3Y": { chest: 23, topLength: 18.5, waist: 18, pantLength: 18   },
        "3-4Y": { chest: 24, topLength: 20.5, waist: 19, pantLength: 22   },
        "4-5Y": { chest: 25, topLength: 22.5, waist: 20, pantLength: 24   },
        "5-6Y": { chest: 26, topLength: 25,   waist: 21, pantLength: 25.5 },
        "6-7Y": { chest: 27, topLength: 27,   waist: 22, pantLength: 27   },
        "7-8Y": { chest: 28, topLength: 29.5, waist: 23, pantLength: 29.5 },
        "8-9Y": { chest: 30, topLength: 31.5, waist: 24, pantLength: 31.5 }
      }
    },

    "tunic-set-below-knee": {
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "topLength", label: "Top length (below knee)" },
        { key: "waist", label: "Garment waist round" },
        { key: "pantLength", label: "Pant length above ankle" }
      ],
      garment: {
        "1-2Y": { chest: 22, topLength: 18,   waist: 17, pantLength: 16   },
        "2-3Y": { chest: 23, topLength: 21.5, waist: 18, pantLength: 18   },
        "3-4Y": { chest: 24, topLength: 24.5, waist: 19, pantLength: 22   },
        "4-5Y": { chest: 25, topLength: 27,   waist: 20, pantLength: 24   },
        "5-6Y": { chest: 26, topLength: 29,   waist: 21, pantLength: 25.5 },
        "6-7Y": { chest: 27, topLength: 31,   waist: 22, pantLength: 27   },
        "7-8Y": { chest: 28, topLength: 33,   waist: 23, pantLength: 29.5 },
        "8-9Y": { chest: 30, topLength: 35,   waist: 24, pantLength: 31.5 }
      }
    },

    "bandhani-plazo": {
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "aboveKnee", label: "Above knee length" },
        { key: "waist", label: "Garment waist round" },
        { key: "pantLength", label: "Pant length above ankle" }
      ],
      garment: {
        "1-2Y": { chest: 22, aboveKnee: 13, waist: 17, pantLength: 16   },
        "2-3Y": { chest: 23, aboveKnee: 15, waist: 18, pantLength: 18   },
        "3-4Y": { chest: 24, aboveKnee: 17, waist: 19, pantLength: 22   },
        "4-5Y": { chest: 25, aboveKnee: 19, waist: 20, pantLength: 24   },
        "5-6Y": { chest: 26, aboveKnee: 21, waist: 21, pantLength: 25.5 },
        "6-7Y": { chest: 27, aboveKnee: 22, waist: 22, pantLength: 27   },
        "7-8Y": { chest: 28, aboveKnee: 23, waist: 23, pantLength: 29.5 },
        "8-9Y": { chest: 30, aboveKnee: 24, waist: 24, pantLength: 31.5 }
      }
    },

    "farsi-set": {
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "aboveKnee", label: "Above knee length" },
        { key: "waist", label: "Garment waist round" },
        { key: "farsiLength", label: "Farsi length" }
      ],
      garment: {
        "1-2Y": { chest: 22, aboveKnee: 13, waist: 17, farsiLength: 18 },
        "2-3Y": { chest: 23, aboveKnee: 15, waist: 18, farsiLength: 21 },
        "3-4Y": { chest: 24, aboveKnee: 17, waist: 19, farsiLength: 24 },
        "4-5Y": { chest: 25, aboveKnee: 19, waist: 20, farsiLength: 26 },
        "5-6Y": { chest: 26, aboveKnee: 21, waist: 21, farsiLength: 28 },
        "6-7Y": { chest: 27, aboveKnee: 22, waist: 22, farsiLength: 30 },
        "7-8Y": { chest: 28, aboveKnee: 23, waist: 23, farsiLength: 32 },
        "8-9Y": { chest: 30, aboveKnee: 24, waist: 24, farsiLength: 34 }
      }
    },

    "lakhnavi-dhoti-set": {
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "aboveKnee", label: "Above knee length" },
        { key: "waist", label: "Garment waist round" },
        { key: "dhotiLength", label: "Dhoti length" }
      ],
      garment: {
        "1-2Y": { chest: 22, aboveKnee: 13, waist: 17, dhotiLength: 18 },
        "2-3Y": { chest: 23, aboveKnee: 15, waist: 18, dhotiLength: 21 },
        "3-4Y": { chest: 24, aboveKnee: 17, waist: 19, dhotiLength: 24 },
        "4-5Y": { chest: 25, aboveKnee: 19, waist: 20, dhotiLength: 26 },
        "5-6Y": { chest: 26, aboveKnee: 21, waist: 21, dhotiLength: 28 },
        "6-7Y": { chest: 27, aboveKnee: 23, waist: 22, dhotiLength: 30 },
        "7-8Y": { chest: 28, aboveKnee: 25, waist: 23, dhotiLength: 32 },
        "8-9Y": { chest: 30, aboveKnee: 27, waist: 24, dhotiLength: 34 }
      }
    },

    "short-tunic-plazo-set": {
      bodyFields: ["chest", "waist", "shoulderKnee", "waistAnkle"],
      body: BODY_4FIELD,
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "aboveKnee", label: "Above knee length" },
        { key: "waist", label: "Garment waist round" },
        { key: "plazoLength", label: "Plazo length" }
      ],
      garment: {
        "1-2Y": { chest: 22, aboveKnee: 13, waist: 17, plazoLength: 16   },
        "2-3Y": { chest: 23, aboveKnee: 15, waist: 18, plazoLength: 18   },
        "3-4Y": { chest: 24, aboveKnee: 17, waist: 19, plazoLength: 22   },
        "4-5Y": { chest: 25, aboveKnee: 19, waist: 20, plazoLength: 24   },
        "5-6Y": { chest: 26, aboveKnee: 21, waist: 21, plazoLength: 25.5 },
        "6-7Y": { chest: 27, aboveKnee: 23, waist: 22, plazoLength: 27   },
        "7-8Y": { chest: 28, aboveKnee: 25, waist: 23, plazoLength: 29.5 },
        "8-9Y": { chest: 30, aboveKnee: 27, waist: 24, plazoLength: 31.5 }
      }
    },

    "boy-kurta-set": {
      bodyFields: ["chest", "waist", "waistAnkle"],
      body: [
        { age: "1-2Y", chest: 20, waist: 19, waistAnkle: 17   },
        { age: "2-3Y", chest: 21, waist: 20, waistAnkle: 19   },
        { age: "3-4Y", chest: 22, waist: 21, waistAnkle: 23   },
        { age: "4-5Y", chest: 23, waist: 22, waistAnkle: 25.5 },
        { age: "5-6Y", chest: 24, waist: 23, waistAnkle: 26.5 },
        { age: "6-7Y", chest: 25, waist: 24, waistAnkle: 28   },
        { age: "7-8Y", chest: 26, waist: 25, waistAnkle: 30.5 },
        { age: "8-9Y", chest: 27, waist: 26, waistAnkle: 32.5 }
      ],
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "elasticWaist", label: "Elasticated waist round" },
        { key: "pantLength", label: "Pant length" }
      ],
      garment: {
        "1-2Y": { chest: 25, elasticWaist: 16, pantLength: 18   },
        "2-3Y": { chest: 26, elasticWaist: 17, pantLength: 21   },
        "3-4Y": { chest: 27, elasticWaist: 18, pantLength: 24   },
        "4-5Y": { chest: 28, elasticWaist: 19, pantLength: 25.5 },
        "5-6Y": { chest: 29, elasticWaist: 20, pantLength: 27   },
        "6-7Y": { chest: 30, elasticWaist: 21, pantLength: 28.5 },
        "7-8Y": { chest: 31, elasticWaist: 22, pantLength: 30   },
        "8-9Y": { chest: 32, elasticWaist: 23, pantLength: 31.5 }
      }
    },

    "lehenga": {
      bodyFields: ["chest", "waist", "waistAnkle"],
      body: [
        { age: "1-2Y", chest: 19, waist: 19, waistAnkle: 17 },
        { age: "2-3Y", chest: 20, waist: 20, waistAnkle: 19 },
        { age: "3-4Y", chest: 21, waist: 21, waistAnkle: 21 },
        { age: "4-5Y", chest: 22, waist: 22, waistAnkle: 22 },
        { age: "5-6Y", chest: 23, waist: 23, waistAnkle: 25 },
        { age: "6-7Y", chest: 24, waist: 24, waistAnkle: 26 },
        { age: "7-8Y", chest: 25, waist: 25, waistAnkle: 27 },
        { age: "8-9Y", chest: 26, waist: 26, waistAnkle: 30 }
      ],
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "elasticWaist", label: "Elasticated waist round" },
        { key: "lehengaLength", label: "Lehenga length" }
      ],
      garment: {
        "1-2Y": { chest: 22, elasticWaist: 17, lehengaLength: 19 },
        "2-3Y": { chest: 23, elasticWaist: 18, lehengaLength: 21 },
        "3-4Y": { chest: 24, elasticWaist: 19, lehengaLength: 23 },
        "4-5Y": { chest: 25, elasticWaist: 20, lehengaLength: 25 },
        "5-6Y": { chest: 26, elasticWaist: 21, lehengaLength: 27 },
        "6-7Y": { chest: 27, elasticWaist: 22, lehengaLength: 29 },
        "7-8Y": { chest: 28, elasticWaist: 23, lehengaLength: 31 },
        "8-9Y": { chest: 30, elasticWaist: 24, lehengaLength: 33 }
      }
    },

    "co-ord-set": {
      bodyFields: ["chest", "waist", "waistAnkle"],
      body: [
        { age: "1-2Y", chest: 19, waist: 19, waistAnkle: 17   },
        { age: "2-3Y", chest: 20, waist: 20, waistAnkle: 19   },
        { age: "3-4Y", chest: 21, waist: 21, waistAnkle: 23   },
        { age: "4-5Y", chest: 22, waist: 22, waistAnkle: 25.5 },
        { age: "5-6Y", chest: 23, waist: 23, waistAnkle: 26.5 },
        { age: "6-7Y", chest: 24, waist: 24, waistAnkle: 28   },
        { age: "7-8Y", chest: 25, waist: 25, waistAnkle: 30.5 },
        { age: "8-9Y", chest: 26, waist: 26, waistAnkle: 32.5 }
      ],
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "elasticWaist", label: "Elasticated waist round" },
        { key: "pantLength", label: "Pant length" }
      ],
      garment: {
        "1-2Y": { chest: 22, elasticWaist: 17, pantLength: 16   },
        "2-3Y": { chest: 23, elasticWaist: 18, pantLength: 18   },
        "3-4Y": { chest: 24, elasticWaist: 19, pantLength: 22   },
        "4-5Y": { chest: 25, elasticWaist: 20, pantLength: 24   },
        "5-6Y": { chest: 26, elasticWaist: 21, pantLength: 25.5 },
        "6-7Y": { chest: 27, elasticWaist: 22, pantLength: 27   },
        "7-8Y": { chest: 28, elasticWaist: 23, pantLength: 29.5 },
        "8-9Y": { chest: 30, elasticWaist: 24, pantLength: 31.5 }
      }
    },

    "dress": {
      bodyFields: ["chest", "shoulderKnee"],
      body: [
        { age: "1-2Y", chest: 19, shoulderKnee: 16   },
        { age: "2-3Y", chest: 20, shoulderKnee: 18.5 },
        { age: "3-4Y", chest: 21, shoulderKnee: 20.5 },
        { age: "4-5Y", chest: 22, shoulderKnee: 22.5 },
        { age: "5-6Y", chest: 23, shoulderKnee: 25   },
        { age: "6-7Y", chest: 24, shoulderKnee: 27   },
        { age: "7-8Y", chest: 25, shoulderKnee: 29.5 },
        { age: "8-9Y", chest: 27, shoulderKnee: 31.5 }
      ],
      garmentFields: [
        { key: "chest", label: "Garment chest round" },
        { key: "dressLength", label: "Dress length" }
      ],
      garment: {
        "1-2Y": { chest: 22, dressLength: 16   },
        "2-3Y": { chest: 23, dressLength: 18.5 },
        "3-4Y": { chest: 24, dressLength: 20.5 },
        "4-5Y": { chest: 25, dressLength: 22.5 },
        "5-6Y": { chest: 26, dressLength: 25   },
        "6-7Y": { chest: 27, dressLength: 27   },
        "7-8Y": { chest: 28, dressLength: 29.5 },
        "8-9Y": { chest: 30, dressLength: 31.5 }
      }
    }
  };

  var SKU_TO_CATEGORY = {
    "891": "tunic-set-till-knee", "892": "tunic-set-till-knee", "894": "tunic-set-till-knee",
    "893": "tunic-set-till-knee", "895": "tunic-set-till-knee", "896": "tunic-set-till-knee",
    "897": "tunic-set-till-knee", "898": "tunic-set-till-knee", "888": "tunic-set-till-knee",
    "887": "tunic-set-till-knee", "640": "tunic-set-till-knee", "638": "tunic-set-till-knee",
    "719": "tunic-set-till-knee", "718": "tunic-set-till-knee",

    "905": "tunic-set-below-knee", "798": "tunic-set-below-knee", "889": "tunic-set-below-knee",
    "890": "tunic-set-below-knee", "722": "tunic-set-below-knee", "720": "tunic-set-below-knee",
    "721": "tunic-set-below-knee", "614": "tunic-set-below-knee", "614L": "tunic-set-below-knee",
    "614G": "tunic-set-below-knee", "808": "tunic-set-below-knee", "809": "tunic-set-below-knee",
    "801": "tunic-set-below-knee", "761": "tunic-set-below-knee", "613Y": "tunic-set-below-knee",
    "613M": "tunic-set-below-knee", "760": "tunic-set-below-knee", "799": "tunic-set-below-knee",
    "793": "tunic-set-below-knee",

    "903": "bandhani-plazo",

    "908": "farsi-set", "907": "farsi-set",

    "943": "lakhnavi-dhoti-set", "942": "lakhnavi-dhoti-set", "941": "lakhnavi-dhoti-set",

    "936": "short-tunic-plazo-set", "935": "short-tunic-plazo-set",
    "806": "short-tunic-plazo-set", "807": "short-tunic-plazo-set"
  };

  // Collection-ID pairs for the 4 "standard, applies to all" categories
  // that have no per-product SKU list. A product must belong to BOTH
  // collections in a rule for that rule to match.
  var COLLECTION_ID = {
    GIRLS: 643366748528,
    DRESSES: 646064505200,
    COORD_DRESS: 643372876144,
    LEHENGA_SETS: 643373531504,
    BOYS_ETHNIC: 642728886640,
    KURTA_SETS: 643373793648
  };

  var COLLECTION_CATEGORY_RULES = [
    { category: "dress", all: [COLLECTION_ID.GIRLS, COLLECTION_ID.DRESSES] },
    { category: "co-ord-set", all: [COLLECTION_ID.COORD_DRESS, COLLECTION_ID.GIRLS] },
    { category: "lehenga", all: [COLLECTION_ID.LEHENGA_SETS, COLLECTION_ID.GIRLS] },
    { category: "boy-kurta-set", all: [COLLECTION_ID.BOYS_ETHNIC, COLLECTION_ID.KURTA_SETS] }
  ];

  function baseSkuCode(sku) {
    if (!sku) return "";
    var m = String(sku).trim().match(/^(\d+)/);
    return m ? m[1] : "";
  }

  function detectCategoryFromSkus(skuList) {
    for (var i = 0; i < skuList.length; i++) {
      var raw = String(skuList[i]).trim();
      if (!raw) continue;
      if (SKU_TO_CATEGORY[raw]) return SKU_TO_CATEGORY[raw];
      var base = baseSkuCode(raw);
      if (base && SKU_TO_CATEGORY[base]) return SKU_TO_CATEGORY[base];
    }
    return null;
  }

  function detectCategoryFromCollections(collectionIds) {
    var idSet = {};
    collectionIds.forEach(function (id) { idSet[id] = true; });
    for (var i = 0; i < COLLECTION_CATEGORY_RULES.length; i++) {
      var rule = COLLECTION_CATEGORY_RULES[i];
      var allPresent = rule.all.every(function (id) { return idSet[id]; });
      if (allPresent) return rule.category;
    }
    return null;
  }

  function max(arr, key) { return arr.reduce(function (m, r) { return Math.max(m, r[key]); }, -Infinity); }
  function min(arr, key) { return arr.reduce(function (m, r) { return Math.min(m, r[key]); }, Infinity); }

  function computeFieldRange(bodyChart, fields) {
    var range = {};
    fields.forEach(function (f) { range[f] = max(bodyChart, f) - min(bodyChart, f); });
    return range;
  }

  function findBestMatch(input, bodyChart, fields, fieldRange) {
    var best = null;
    var bestScore = Infinity;
    bodyChart.forEach(function (row) {
      var score = 0;
      fields.forEach(function (f) {
        var diff = (input[f] - row[f]) / (fieldRange[f] || 1);
        score += diff * diff;
      });
      if (score < bestScore) { bestScore = score; best = row; }
    });
    return best;
  }

  // Finds a swatch <label> with matching visible text WITHIN a specific
  // product card (not document-wide) and clicks it — scoping to the
  // card matters here since a page has many products, each with its
  // own "1-2Y" etc. labels.
  function selectVariantOptionWithin(container, sizeLabel) {
    var target = sizeLabel.trim().toLowerCase();
    var labels = container.querySelectorAll("label[for]");
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent.trim().toLowerCase() === target) {
        labels[i].click();
        return true;
      }
    }
    return false;
  }

  /* =========================================================
     GLOBAL POPUP WIRING
     One shared modal, populated per-click based on whichever
     product card's swatch was clicked.
     ========================================================= */
  var popupRoot = document.getElementById("size-rec-global");
  if (!popupRoot) return; // snippet not included on this page

  var overlay   = document.getElementById("size-rec-global-overlay");
  var closeBtn  = document.getElementById("size-rec-global-close");
  var form      = document.getElementById("size-rec-global-form");
  var resultBox = document.getElementById("size-rec-global-result");
  var emptyBox  = document.getElementById("size-rec-global-empty");
  var productNameEl = document.getElementById("size-rec-global-product-name");

  if (!overlay || !closeBtn || !form || !resultBox) return;

  var activeChart = null;
  var activeFieldRange = null;
  var activeCategory = null;
  var activeProductEl = null;
  var activeProductId = null;

  function openModal() {
    overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";
    resetForm();
  }

  function resetForm() {
    form.reset();
    resultBox.hidden = true;
    resultBox.innerHTML = "";
  }

  closeBtn.addEventListener("click", closeModal);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) closeModal();
  });
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) closeModal();
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (!activeChart) return;

    var data = new FormData(form);
    var input = {};
    var allValid = true;
    activeChart.bodyFields.forEach(function (f) {
      var v = parseFloat(data.get(f));
      input[f] = v;
      if (isNaN(v)) allValid = false;
    });
    if (!allValid) return;

    var match = findBestMatch(input, activeChart.body, activeChart.bodyFields, activeFieldRange);
    var garment = activeChart.garment[match.age];
    var selected = activeProductEl ? selectVariantOptionWithin(activeProductEl, match.age) : false;

    var rowsHtml = activeChart.garmentFields.map(function (f) {
      return "<tr><td>" + f.label + "</td><td>" + garment[f.key] + '"</td></tr>';
    }).join("");

    resultBox.hidden = false;
    resultBox.innerHTML =
      '<div class="size-rec__result-size">Recommended: ' + match.age + "</div>" +
      '<div class="size-rec__result-note">' +
        (selected
          ? "We've selected this size for you below."
          : "Select <strong>" + match.age + "</strong> in the size options below.") +
      "</div>" +
      '<table class="size-rec__result-table">' + rowsHtml + "</table>" +
      '<button type="button" class="size-rec__result-cta">Done</button>';

    var doneBtn = resultBox.querySelector(".size-rec__result-cta");
    if (doneBtn) doneBtn.addEventListener("click", closeModal);

    resultBox.scrollIntoView({ behavior: "smooth", block: "start" });

    popupRoot.dispatchEvent(new CustomEvent("size-rec:matched", {
      bubbles: true,
      detail: { category: activeCategory, productId: activeProductId, age: match.age, garment: garment }
    }));
  });

  // Show/hide the 4 possible input fields based on the active category.
  function applyFieldVisibility(chart, hasChart) {
    FIELD_ORDER.forEach(function (f) {
      var wrapper = form.querySelector('[data-field="' + f + '"]');
      if (!wrapper) return;
      var input = wrapper.querySelector("input");
      var active = hasChart && chart.bodyFields.indexOf(f) !== -1;
      wrapper.hidden = !active;
      if (input) input.required = active;
    });
  }

  /* =========================================================
     EVENT DELEGATION — every size swatch on the page, across
     every product card, on every collection/grid page. Works
     for cards that don't exist yet at page load too (infinite
     scroll, filtered re-renders, etc.) since it's delegated to
     `document` rather than bound to individual elements.

     Opens once per PRODUCT per page view: the first swatch click
     on a given product opens the popup; further clicks on that
     same product's swatches (any size) won't reopen it until the
     page is refreshed. Clicking a swatch on a DIFFERENT product
     still opens it, since it's a different item needing its own
     guidance. Tracked in-memory only — nothing persisted, so a
     refresh resets it for every product again.
     ========================================================= */
  var openedProductIds = {};

  document.addEventListener("click", function (e) {
    var label = e.target.closest(".product-item__size");
    if (!label) return;

    var productItem = label.closest("product-item");
    if (!productItem) return;

    var productId = productItem.getAttribute("data-product-id") || "unknown-product";
    if (openedProductIds[productId]) return; // already opened once for this product

    var skuAttr = productItem.getAttribute("data-skus") || "";
    var skuList = skuAttr.split(",").map(function (s) { return s.trim(); }).filter(Boolean);

    var collAttr = productItem.getAttribute("data-collection-ids") || "";
    var collectionIds = collAttr.split(",").map(function (s) { return s.trim(); }).filter(Boolean).map(Number);

    var category = detectCategoryFromSkus(skuList) || detectCategoryFromCollections(collectionIds);

    // No match for this product — let the swatch click just select
    // the variant normally, don't open the popup, and don't mark it
    // as "opened" (so it's re-checked if e.g. SKU data changes later).
    if (!category) return;

    openedProductIds[productId] = true;

    var chart = SIZE_CHARTS[category];
    var hasChart = !!(chart && chart.body && chart.garment);

    activeCategory = category;
    activeChart = hasChart ? chart : null;
    activeFieldRange = hasChart ? computeFieldRange(chart.body, chart.bodyFields) : null;
    activeProductEl = productItem;
    activeProductId = productId;

    if (productNameEl) {
      var titleEl = productItem.querySelector(".product-item-meta__title");
      var productTitle = titleEl ? titleEl.textContent.trim() : "";
      if (productTitle) {
        productNameEl.textContent = productTitle;
        productNameEl.hidden = false;
      } else {
        productNameEl.hidden = true;
      }
    }

    applyFieldVisibility(chart, hasChart);

    if (!hasChart) {
      form.hidden = true;
      if (emptyBox) emptyBox.hidden = false;
    } else {
      form.hidden = false;
      if (emptyBox) emptyBox.hidden = true;
    }

    resetForm();
    openModal();
  });
})();